<template>
  <v-dialog
    v-model="dialog"
    width="100%"
  >
    <template v-slot:activator="{ on }">
      <v-btn style='margin: 2px' color="primary" :disabled='disabled' v-on="on" ref='activatorButton'>
        Ver Firmantes<v-icon>mdi-account-details</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>Firmantes en el Contrato {{docTitle}}</v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="firmantes"
          :loading="loading"
          single-select
          show-select
          single-expand
          show-expand
          :expanded.sync='expanded'
          @click:row="rowSelected"
          :options.sync='options'
          :server-items-length='total'
          :footer-props='{
            itemsPerPageOptions: [5, 10, 20, 50]
          }'
          no-data-text="No hay firmantes disponibles">
          <template v-slot:top>
            <slotbar fluid :visible='dialog' :slots='2' :slotWidth='400'>
              <template v-slot:slot1></template>
              <template v-slot:slot2>
                <v-btn
                  v-if="docNoTerminado"
                  color="primary"
                  :disabled="emptySelected"
                  @click="confirmDialog = true"
                  title="Eliminar firmante"
                >Eliminar<v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </template>
            </slotbar>
          </template>
          <template v-slot:item.data-table-select="{ item, isSelected }">
            <v-checkbox v-model='isSelected'>
              <template v-if='docNoTerminado' v-slot:prepend>
                <v-icon color='primary' title='Eliminar firmante' @click='clickTrash(item, isSelected)'>mdi-delete</v-icon>
              </template>
            </v-checkbox>
          </template>
          <template v-slot:item.firmanteStatus="{ item }">
            {{ getNombreStatus(item.firmanteStatus) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan='headers.length'>
              <v-row><v-col></v-col></v-row>
              <v-row>
                <v-col v-for='(dato, index) in headersContacto' :key='index'>
                  <v-text-field :title='dato.title' :value='item.contacto[dato.value]' :placeholder='"Sin "+dato.title' filled readonly>
                    <template v-slot:prepend>
                      <v-icon :title='dato.title'>{{dato.icon}}</v-icon>
                      <span :title='dato.title' style='color: gray; font-weight: bold;'>{{dato.text}}</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-text></v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <slotbar fluid no-gutters :visible='dialog' :slots='2' :slotWidth='500'>
          <template v-slot:slot1>
            <v-btn
              v-show='docNoTerminado && !emptyFirmantes'
              @click='$emit("terminarEvent")'
              color='primary'
              text
            >Terminar Documento</v-btn>
          </template>
          <template v-slot:slot2>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Cerrar
            </v-btn>
          </template>
        </slotbar>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="confirmDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">Eliminar firmante</v-card-title>
        <v-card-text>
          ¿Desea eliminar al firmante del documento?
        </v-card-text>
        <v-card-text class='text-center'>
          <span style='font-weight: bold'>{{ selectedFirmanteNombre }}</span>
          <br>
          <span style='font-weight: bold'>{{ selectedFirmanteRol }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="confirmDialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="quitarFirmante">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import slotbar from '@/components/custom/slotbar.vue';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  export default {
    components: {
      slotbar,
    },
    props: {
      doc: Array,
      disabled: Boolean,
    },
    data () {
      return {
        dialog: false,
        confirmDialog: false,
        loading: false,
        firmantes: [],
        selected: [],
        expanded: [],
        headers: [
          { text: 'Nombre', value: 'contacto.nombre'},
          { text: 'Rol', value: 'razon'},
          { text: 'Estado', value: 'firmanteStatus'},
          { text: 'Campo', value: 'signatureXPathParent'},
          { text: 'Información de contacto', value: 'data-table-expand'},
        ],
        headersContacto: [
          { text: '', value: 'correo', title: 'correo', icon: 'mdi-email' },
          { text: '', value: 'sms', title: 'teléfono', icon: 'mdi-cellphone' },
          { text: 'RFC', value: 'rfc', title: 'RFC', icon: '' },
          { text: 'Razón Social', value: 'razonSocial', title: 'razón social', icon: '' },
        ],
        options: {
          sortBy: [],
          itemsPerPage: 5,
        },
        total: 0,
        firstLoad: true,
      }
    },
    computed: {
      emptySelected() {
        if (this.selected.length === 0) return true;
        return false;
      },
      docNoTerminado() {
        if (this.doc.length > 0 && typeof this.doc[0].status === 'string' && this.doc[0].status === 'NO_FIRMADO') return true;
        return false;
      },
      emptyFirmantes() {
        if (this.firmantes.length === 0) return true;
        return false;
      },
      docTitle() {
        if (this.doc.length > 0 && typeof this.doc[0].title === 'string') return `"${this.doc[0].title}"`;
        return '';
      },
      selectedFirmanteNombre() {
        if (this.selected.length === 0) return '';
        return this.selected[0].contacto.nombre;
      },
      selectedFirmanteRol() {
        if (this.selected.length === 0) return '';
        return this.selected[0].razon;
      },
    },
    methods:{
      async getListFirmantes(){
        const defaultToastMessage = 'Error al obtener la lista de firmantes.';
        const defaultConsoleMessage = 'getListFirmantes error';
        try {
          const clienteId = this.$store.getters.getClient;
          const documentoId = this.doc[0].id;
          const options = this.options;
          const result = await this.$store.dispatch('listFirmantes', {clienteId, documentoId, options});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          console.debug('getListFirmantes result', result);
          this.total = result.totalElements;
          this.firmantes = result.content;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      async quitarFirmante() {
        const defaultToastMessage = 'Error al quitar el firmante.';
        const defaultConsoleMessage = 'quitarFirmante error';
        try {
          const clienteId = this.$store.getters.getClient;
          const documentoId = this.doc[0].id;
          const firmanteId = this.selected[0].id;
          const result = await this.$store.dispatch('deleteFirmante', {clienteId, documentoId, firmanteId});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          this.$emit('firmanteEliminadoEvent');
          this.selected = [];
          this.getListFirmantes();
          this.confirmDialog = false;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      rowSelected(obj) {
        // console.debug('rowSelected object %o', obj);
        if (this.selected.length > 0) {
          const sel = this.selected[0];
          this.selected = [];
          if (sel.id !== obj.id) this.selected.push(obj);
        } else this.selected.push(obj);
      },
      clickTrash(item, isSelected) {
        if (isSelected) this.rowSelected(item);
        this.confirmDialog = true;
      },
      getNombreStatus(status) {
        switch (status) {
          case 'NO_FIRMO': return 'No firmó';
          case 'FIRMO': return 'Firmó';
          case 'REHUSADO': return 'Rehusado';
          case 'CANCELADO': return 'Cancelado';
          default: return 'Desconocido';
        }
      },
    },
    watch: {
      dialog() {
        if (this.dialog) {
          console.debug('this.doc: ', this.doc);
          if (this.firstLoad) this.firstLoad = false;
          else this.getListFirmantes();
        } else {
          this.selected = [];
        }
      },
      options() {
        console.debug('watch options', this.options);
        this.getListFirmantes();
      }
    }
  }
</script>